var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
var EstablishementPermissions = /** @class */ (function (_super) {
    __extends(EstablishementPermissions, _super);
    function EstablishementPermissions(obj) {
        if (obj === void 0) { obj = []; }
        var _this = _super.call(this) || this;
        _this.all = false;
        _this.partners = false;
        _this.orders = false;
        _this.payment_methods = false;
        _this.order_supp_data = false;
        _this.customers = false;
        _this.establishment_customers = false;
        _this.establishment_identity_customers_read = false;
        _this.establishment_identity_customers_create = false;
        _this.establishment_identity_customers_update = false;
        _this.email_update = false;
        _this.ticket_transfer = false;
        _this.notification_campaign = false;
        _this.products = false;
        _this.categories = false;
        _this.invoices = false;
        _this.establishment_details = false;
        _this.establishment_shared_resource = false;
        _this.payment_config = false;
        _this.statistics = false;
        _this.ticketing = false;
        _this.bar = false;
        _this.manual_orders = false;
        _this.schedule_ticket = false;
        _this.product_type_default = false;
        _this.product_type_event = false;
        _this.product_type_food = false;
        _this.product_type_bar = false;
        _this.product_type_event_nightclub = false;
        _this.product_type_sport_basketball = false;
        _this.event_pos_access = false;
        _this.bar_pos_access = false;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        EstablishementPermissions.buildFromJson(_this, obj);
        return _this;
    }
    EstablishementPermissions.buildFromJson = function (instance, json) {
        if (json) {
            for (var _i = 0, json_1 = json; _i < json_1.length; _i++) {
                var prop = json_1[_i];
                instance[prop] = true;
            }
        }
    };
    EstablishementPermissions.prototype.exportToJson = function () {
        var JSONPermissions = [];
        if (this.all) {
            JSONPermissions.push("all");
        }
        if (this.partners) {
            JSONPermissions.push("partners");
        }
        if (this.orders) {
            JSONPermissions.push("orders");
        }
        if (this.payment_methods) {
            JSONPermissions.push("payment_methods");
        }
        if (this.order_supp_data) {
            JSONPermissions.push("order_supp_data");
        }
        if (this.customers) {
            JSONPermissions.push("customers");
        }
        if (this.establishment_identity_customers_read) {
            JSONPermissions.push("establishment_identity_customers_read");
        }
        if (this.establishment_identity_customers_create) {
            JSONPermissions.push("establishment_identity_customers_create");
        }
        if (this.establishment_identity_customers_update) {
            JSONPermissions.push("establishment_identity_customers_update");
        }
        if (this.establishment_customers) {
            JSONPermissions.push("establishment_customers");
        }
        if (this.email_update) {
            JSONPermissions.push("email_update");
        }
        if (this.ticket_transfer) {
            JSONPermissions.push("ticket_transfer");
        }
        if (this.notification_campaign) {
            JSONPermissions.push("notification_campaign");
        }
        if (this.products) {
            JSONPermissions.push("products");
        }
        if (this.categories) {
            JSONPermissions.push("categories");
        }
        if (this.invoices) {
            JSONPermissions.push("invoices");
        }
        if (this.establishment_details) {
            JSONPermissions.push("establishment_details");
        }
        if (this.establishment_shared_resource) {
            JSONPermissions.push("establishment_shared_resource");
        }
        if (this.payment_config) {
            JSONPermissions.push("payment_config");
        }
        if (this.statistics) {
            JSONPermissions.push("statistics");
        }
        if (this.ticketing) {
            JSONPermissions.push("ticketing");
        }
        if (this.bar) {
            JSONPermissions.push("bar");
        }
        if (this.manual_orders) {
            JSONPermissions.push("manual_orders");
        }
        if (this.schedule_ticket) {
            JSONPermissions.push("schedule_ticket");
        }
        if (this.product_type_default) {
            JSONPermissions.push("product_type_default");
        }
        if (this.product_type_event) {
            JSONPermissions.push("product_type_event");
        }
        if (this.product_type_food) {
            JSONPermissions.push("product_type_food");
        }
        if (this.product_type_bar) {
            JSONPermissions.push("product_type_bar");
        }
        if (this.product_type_event_nightclub) {
            JSONPermissions.push("product_type_event_nightclub");
        }
        if (this.product_type_sport_basketball) {
            JSONPermissions.push("product_type_sport_basketball");
        }
        if (this.event_pos_access) {
            JSONPermissions.push("event_pos_access");
        }
        if (this.bar_pos_access) {
            JSONPermissions.push("bar_pos_access");
        }
        return JSONPermissions;
    };
    return EstablishementPermissions;
}(Model));
export default EstablishementPermissions;
//# sourceMappingURL=EstablishmentPermissions.js.map